import { useEffect, useRef, useState } from "react";

/**
 * Scroll-triggered reveal. Pass `as` to change the wrapper tag and `image`
 * to use the clip-path reveal instead of the translate fade.
 */
export default function Reveal({
  children,
  as: Tag = "div",
  image = false,
  delay = 0,
  className = "",
  ...rest
}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (typeof IntersectionObserver === "undefined") {
      setVisible(true);
      return;
    }
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  const base = image ? "reveal-image" : "reveal";
  const cls = `${base} ${visible ? "is-visible" : ""} ${className}`.trim();
  const style = delay ? { transitionDelay: `${delay}ms` } : undefined;
  return (
    <Tag ref={ref} className={cls} style={style} {...rest}>
      {children}
    </Tag>
  );
}
